import FullClaimInfoForm from "./FullClaimInfoForm";

export default FullClaimInfoForm;
